import { useEffect, useRef, useState } from 'react';

export const REFRESH_EVENT = 'admin-refresh';

// Calls fn every `ms` and whenever the dashboard's top Refresh button is pressed; returns the last run time.
export const useAutoRefresh = (fn, ms = 60000) => {
  const ref = useRef(fn);
  const [at, setAt] = useState(new Date());
  useEffect(() => { ref.current = fn; }, [fn]);
  useEffect(() => {
    const run = () => { ref.current(); setAt(new Date()); };
    const id = setInterval(() => { if (!document.hidden) run(); }, ms);
    window.addEventListener(REFRESH_EVENT, run);
    return () => { clearInterval(id); window.removeEventListener(REFRESH_EVENT, run); };
  }, [ms]);
  return [at, setAt];
};

export const LastUpdated = ({ at, testId, dark = false }) => (
  <span className={`text-[11px] ${dark ? 'text-white/45' : 'text-slate-400'}`} data-testid={testId}>
    Auto-refreshes every minute · updated {at.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
  </span>
);
